// src/stores/useLegalModalStore.ts
// Controls which (if any) legal modal is currently open.
// Mirrors the pattern used by useAuthStore / usePaymentStore.

import { create } from 'zustand';

export type LegalModalId =
  | 'privacy'
  | 'cookies'
  | 'terms'
  | 'accessibility'
  | null;

interface LegalModalState {
  openModal: LegalModalId;
  open:  (id: NonNullable<LegalModalId>) => void;
  close: () => void;
}

export const useLegalModalStore = create<LegalModalState>((set) => ({
  openModal: null,
  open:  (id) => set({ openModal: id }),
  close: ()   => set({ openModal: null }),
}));